import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import type { FilterKey } from '@core/Entities/Search/QueryParams.entity';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { createPathFromFilters } from '@core/Utils/Search/CreatePathFromFilters';

import { applyFilterChanges } from './ApplyFiltersChange';

/**
 * Given a list of filters and a pair of range filter IDs (e.g. year__gte & year__lte) -
 * returns a function that creates a link for a set of range filters with the same value.
 * If a filter value is not selected, the link will add it.
 */
export const createFiltersLinkForRangeFilterValue = ({
  filters,
  filterIds,
  root,
  tenant,
}: {
  filters: Filter[];
  filterIds: [FilterKey, FilterKey];
  root: PlpRoot;
  tenant: Tenant | undefined;
}) => {
  return (value: string) => {
    const newFilters = applyFilterChanges(filters, [
      {
        id: filterIds[0],
        value: value,
      },
      {
        id: filterIds[1],
        value: value,
      },
    ]);
    const path = createPathFromFilters(newFilters ?? [], root);

    if (!tenant) return path;

    return path;
  };
};
